export default __webpack_public_path__ + "static/article-0-632f5351d0a0113c5fd1e21a6178c64c.jpg";